module.exports = __webpack_public_path__ + "static/media/favicon.80755ac8.ico";